module.exports = __webpack_public_path__ + "static/Pridatect-51da6a888c49c501fe11c11975b6dfca.jpg";